import { getAuth } from 'firebase/auth';
import {
	arrayUnion,
	doc,
	getFirestore,
	increment,
	setDoc,
} from 'firebase/firestore';
import React from 'react';

import {
	enterCheck,
	failXTime,
	numberOfAnswers,
	numberOfGuesses,
	numberOfRounds,
} from './Constants';
import GameLayout from './GameLayout';
import rejectedAnswers from './rejectedAnswers.json';

const playedQuestions = {};
let roundScore = 0;

const Game = ({
	answers,
	categories = {},
	highScore,
	questionOfTheDay,
	setHighScore,
	PokiSDK,
}) => {
	const firestore = getFirestore();
	const user = getAuth().currentUser;
	const numberOfGuessesOrStatic = numberOfGuesses;
	const processGuess = (guess) => {
		guess = guess
			.toLowerCase()
			.trim()
			.replace(/[^\w\d\s]/g, '')
			.replace(/(.)(?=\1)/g, '');
		const suffixes = [
			'pdf',
			'in space',
			'in spanish',
			'2020',
			'2021',
			'2022',
		].concat(rejectedAnswers);
		suffixes.forEach((suffix) => {
			if (guess.substring(guess.length - suffix.length - 1) === ' ' + suffix) {
				guess = guess.substring(0, guess.length - suffix.length);
			}
		});

		const prefixes = [].concat(rejectedAnswers);
		prefixes.forEach((prefix) => {
			if (guess.substring(0, prefix.length + 1) === prefix + ' ') {
				guess = guess.substring(prefix.length + 1);
			}
		});

		guess.replace(/mister/g, 'mr');
		guess.replace(/miss/g, 'ms');
		guess.replace(/misses/g, 'mrs');
		guess.replace(/doctor/g, 'dr');

		return guess;
	};

	const [round, setRound] = React.useState(1);
	const [wrong, setWrong] = React.useState(0);
	const [score, setScore] = React.useState(0);
	const [category, setCategory] = React.useState(null);
	const [query, setQuery] = React.useState(null);

	const [numberOfRoundsOrQOTD, setNumberOfRoundsOrQOTD] =
		React.useState(numberOfRounds);
	const [loadingCategory, setLoadingCategory] = React.useState(null);
	const [response, setResponse] = React.useState('');
	const [correctAnswers, setCorrectAnswers] = React.useState([]);

	const [processedAnswers, setProcessedAnswers] = React.useState([]);
	const [giveUp, setGiveup] = React.useState(false);
	const [thisRound, setThisRound] = React.useState([]);
	const [showResults, setShowResults] = React.useState(false);
	const [firstGame, setFirstGame] = React.useState(true);

	const loadQuery = (event, tempCategory, tempQuery = null, tempRound = 1) => {
		if (event && enterCheck(event)) {
			return;
		}

		if (PokiSDK !== null && tempRound === 1) {
			PokiSDK.gameplayStart();
			if (firstGame) {
				setFirstGame(false);
			} else {
				PokiSDK.commercialBreak();
			}
		}

		if (answers === null) {
			console.log('loading', tempCategory);
			return setLoadingCategory(tempCategory);
		}

		let newCategory = tempCategory;
		let newQuery = tempQuery;

		if (category === null) {
			setCategory(newCategory);
			setNumberOfRoundsOrQOTD(
				newCategory === 'Question of the Day' ? 1 : numberOfRounds
			);
		}

		if (newQuery === null) {
			const categoryNames = Object.keys(categories);
			while (newCategory === 'Random' || categories[newCategory].hidden) {
				newCategory =
					categoryNames[Math.floor(Math.random() * categoryNames.length)];
			}

			if (newCategory in playedQuestions === false) {
				playedQuestions[newCategory] = [];
			}

			while (
				newQuery === null ||
				playedQuestions[newCategory].indexOf(newQuery) > -1
			) {
				newQuery =
					categories[newCategory].queries[
						Math.floor(categories[newCategory].queries.length * Math.random())
					];
			}
		}
		setQuery(newQuery);
		setProcessedAnswers(() => {
			return answers[newQuery].map((answer) => processGuess(answer));
		});

		if (newCategory !== 'Question of the Day') {
			if (
				newCategory in playedQuestions &&
				playedQuestions[newCategory].length + 1 ===
					categories[newCategory].queries.length
			) {
				playedQuestions[newCategory] = [];
			} else {
				playedQuestions[newCategory].push(newQuery);
			}
		}
		refocusInput('mainInput');
	};

	const submitAnswer = (event) => {
		if (enterCheck(event) || response.trim().length === 0) {
			return document.getElementById('mainInput').focus();
		}
		const winConditions = (guess, answer) => {
			const minimumWordLength = 4;

			if (guess === answer) {
				return true;
			}

			if (guess.slice(0, -1) === answer || guess === answer.slice(0, -1)) {
				return true;
			}

			const spacelessGuess = guess.replace(/\W/g, '');
			const spacelessAnswer = answer.replace(/\W/g, '');
			if (
				spacelessGuess.length >= minimumWordLength &&
				spacelessAnswer.indexOf(spacelessGuess) > -1
			) {
				return true;
			}

			if (
				guess
					.split(' ')
					.reduce(
						(acc, word) =>
							word.length > minimumWordLength &&
							(answer.indexOf(word) > -1 || spacelessAnswer.indexOf(word) > -1)
								? true
								: acc,
						false
					)
			) {
				return true;
			}
			return false;
		};

		const processedGuess = processGuess(response);
		let points = 0;
		processedAnswers.forEach(
			(answer, index) =>
				!correctAnswers[index] &&
				winConditions(processedGuess, answer) &&
				(correctAnswers[index] = true) &&
				(points += 1000 * (numberOfAnswers - index))
		);
		let newWrong = wrong;
		if (points === 0) {
			newWrong++;
		} else {
			if (
				correctAnswers.filter((val) => val).length === processedAnswers.length
			) {
				setWrong(numberOfGuessesOrStatic);
				setGiveup(true);
			}
		}
		setResponse('');
		setCorrectAnswers(correctAnswers);
		if (newWrong === numberOfGuessesOrStatic) {
			const newRound = thisRound.concat([{ query, score: roundScore }]);
			setThisRound(newRound);
		}
		setWrong(newWrong);
		setScore(score + points);
		roundScore += points;
	};

	const giveUpFunction = () => {
		setGiveup(true);
		setWrong(numberOfGuessesOrStatic);
		const newRound = thisRound.concat([{ query, score: roundScore }]);
		setThisRound(newRound);
		if (round === numberOfRoundsOrQOTD) {
			updateStats(newRound);
		}
	};

	const updateStats = (roundData) => {
		if (user === null) {
			return;
		}
		const newScore = roundData.reduce((acc, val) => acc + val.score, 0);
		setDoc(
			doc(firestore, `UserData/${user.uid}`),
			{
				allTimeScore: increment(newScore),
				recentlyPlayed: arrayUnion(...roundData.map((val) => val.query)),
				questionsPlayed: increment(numberOfRoundsOrQOTD),
				lastQuery: query,
				lastQueryScore: newScore,
				...(newScore > highScore && {
					highScore: { score: newScore, category },
				}),
			},
			{ merge: true }
		);
	};

	const nextRound = (event) => {
		if (enterCheck(event)) {
			return;
		}
		setShowResults(false);
		setGiveup(false);
		setResponse('');
		setWrong(0);
		roundScore = 0;
		setCorrectAnswers([]);
		if (round < numberOfRoundsOrQOTD) {
			refocusInput('mainInput');
			setRound(round + 1);
			loadQuery(event, category, null, round + 1);
		} else {
			updateStats(thisRound.concat([{ query, score: roundScore }]));
			setRound(1);
			setScore(0);
			setCategory(null);
			setQuery(null);
			setThisRound([]);
			if (score > highScore) {
				setHighScore(score);
			}
		}
	};

	const shareText = () =>
		wrong === numberOfGuessesOrStatic &&
		answers[query].reduce(
			(acc, answer, index) =>
				`${acc}\n${(correctAnswers[index] ? '🟦' : '⬜').repeat(
					Math.floor(answer.length * 0.66)
				)}`,
			`Google Feud - ${query}\n`
		) + `\n\n${score.toLocaleString()} points`;

	const refocusInput = (whichInput) => {
		if (document.getElementById(whichInput)) {
			document.getElementById(whichInput).blur();
			setTimeout(() => {
				if (document.getElementById(whichInput)) {
					document.getElementById(whichInput).focus();
				}
			}, failXTime);
		}
	};

	return (
		<GameLayout
			answers={answers}
			categories={categories}
			category={category}
			correctAnswers={correctAnswers}
			giveUp={giveUp}
			giveUpFunction={giveUpFunction}
			highScore={highScore}
			loadingCategory={loadingCategory}
			loadQuery={loadQuery}
			nextRound={nextRound}
			numberOfGuessesOrStatic={numberOfGuessesOrStatic}
			numberOfRoundsOrQOTD={numberOfRoundsOrQOTD}
			PokiSDK={PokiSDK}
			processedAnswers={processedAnswers}
			query={query}
			questionOfTheDay={questionOfTheDay}
			response={response}
			round={round}
			score={score}
			setLoadingCategory={setLoadingCategory}
			setResponse={setResponse}
			setRound={setRound}
			setShowResults={setShowResults}
			setWrong={setWrong}
			shareText={shareText}
			showResults={showResults}
			submitAnswer={submitAnswer}
			thisRound={thisRound}
			wrong={wrong}
		/>
	);
};

export default Game;
